import { computed, ref, Ref, onUnmounted } from "vue";

import useBonusomatData from "./use-bonusomat-data";
import { useLoyaltyPlayerStatus } from "@/loyalty/composables/use-loyalty-player-status";
import { BonusomatUtils } from "../utils/bonusomat-utils";

export function useQuestDetails(quest: Ref<any>, isOnLogoutPage?: boolean) {
    const { bonusomatPlayerStatus } = useLoyaltyPlayerStatus();
    const { bonusomatPlayerData, loadBonusomatPlayerData } = bonusomatPlayerStatus;

    const { loadQuests, openedQuest } = useBonusomatData();

    const isActive = computed(() => {
        return quest.value.id === bonusomatPlayerData.value.activeQuestId;
    });
    const isCompleted = computed(() => quest.value.completed);
    const isBonusAward = computed(() => quest.value?.awardType?.toLowerCase() == "bonus");
    const isPlayable = computed(() => BonusomatUtils.dateIsInPast(quest.value?.startDate));

    const remainingTasks = computed(() => quest.value?.totalTasks - quest.value?.completedTasks);

    const tasksCountLabel = computed(() => {
        const tasksCount = quest.value?.totalTasks;

        switch (tasksCount) {
            case 1:
                return `${quest.value.totalTasks} úkol`;
            case 2:
            case 3:
            case 4:
                return `${quest.value.totalTasks} úkoly`;
            default:
                return `${quest.value.totalTasks} úkolů`;
        }
    });

    const completedTasksLabel = computed(() => {
        const totalTasksCount = quest.value?.totalTasks;
        const completedTasksCount = quest.value?.completedTasks;
        const questsWord = totalTasksCount == 1 ? "úkol" : "úkolů";

        return `${completedTasksCount}/${totalTasksCount} ${questsWord}`;
    });

    const remainingTime = ref("");

    const startingTime = computed(() => {
        return BonusomatUtils.getStartTimeLabel(quest.value?.startDate);
    });

    const updateRemainingTime = async () => {
        const total = Date.parse(quest.value?.endDate) - Date.parse(new Date().toISOString());
        const seconds = total <= 0 ? 0 : Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
        const days = Math.floor(total / (1000 * 60 * 60 * 24));

        if (days > 0) {
            remainingTime.value = `${days}d ${hours}h`;
        } else {
            remainingTime.value =
                `${(hours < 10 ? "0" : "") + hours}:` +
                `${(minutes < 10 ? "0" : "") + minutes}:` +
                `${(seconds < 10 ? "0" : "") + seconds}`;
        }

        if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0 && !isOnLogoutPage) {
            setTimeout(async () => {
                await loadQuests();
                await loadBonusomatPlayerData();

                if (openedQuest.value?.id && quest.value?.id && openedQuest.value.id == quest.value.id) {
                    openedQuest.value = null;
                }
            }, 500);
        }
    };

    if (!isOnLogoutPage) {
        const intervalId = setInterval(updateRemainingTime, 1000);

        onUnmounted(() => {
            clearInterval(intervalId);
        });
    }

    updateRemainingTime();

    const questProgress = computed(() => {
        // return (quest.value.completedTasks / quest.value.totalTasks) * 100;
        return quest.value.progress;
    });

    const questTimeLabel = computed(() => {
        return isPlayable.value ? remainingTime.value : startingTime.value;
    });

    return {
        isActive,
        isCompleted,
        isBonusAward,
        isPlayable,
        remainingTasks,
        tasksCountLabel,
        completedTasksLabel,
        remainingTime,
        startingTime,
        questProgress,
        questTimeLabel,
    };
}
